<template>
  <router-view />
</template>

<script>
export default {
  name: 'product-pages-container',
};
</script>
